var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h3',{staticClass:"mb-3 hp-text-color-black-1"},[_vm._v("Клиенты")])]),_c('b-col',[_c('ClientsTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }